import { render } from "./StripeForm.vue?vue&type=template&id=8f64988a"
import script from "./StripeForm.vue?vue&type=script&lang=js"
export * from "./StripeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__